// "Cookievoorkeuren" in the legal menu (menu item class `cookie-renew`, which
// WordPress puts on the <li>). Reopens the Cookiebot consent dialog. When
// Cookiebot is not loaded (staging: empty CBID) the click is a quiet no-op.
const cookieRenew = () => {
	document.addEventListener('click', (event) => {
		const link = event.target.closest('.cookie-renew a, a.cookie-renew');
		if (!link) {
			return;
		}
		event.preventDefault();
		if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
			window.Cookiebot.renew();
		}
	});
};

export default cookieRenew;
